export default __webpack_public_path__ + "7485ec70b5da05641d623b6f4cf8ccc1.svg";